<div class="py-4 container-fluid teach-compensation-report-details-page">
  <div class="teach-compensation-report-details-heading">
    <h4 class="mb-0 teach-compensation-report-details-title">
      @if (teacherDisplayName(); as teacherName) {
        การจัดการคำขอสอนชดเชย - รายการคำขอสอนชดเชย {{ teacherName }}
      } @else {
        การจัดการคำขอสอนชดเชย - รายการคำขอสอนชดเชย
      }
    </h4>
  </div>

  <div class="teach-compensation-report-details-card">
    <div class="teach-compensation-report-details-card-body">
      <div class="teach-compensation-report-details-toolbar" [formGroup]="form">
        <div class="teach-compensation-report-details-toolbar-filters">
          <div class="teach-compensation-report-details-filter">
            <app-select
              label="เทอมการศึกษา"
              formControlName="academicTerm"
              [options]="academicTermOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="teach-compensation-report-details-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="teach-compensation-report-details-filter">
            <app-select
              label="ปีการศึกษา"
              formControlName="year"
              [options]="yearOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="teach-compensation-report-details-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="teach-compensation-report-details-filter">
            <app-select
              label="เดือน (วันที่ลา/หยุด)"
              formControlName="month"
              [options]="monthOptions"
              bindLabel="label"
              bindValue="value"
              [searchable]="false"
              [clearable]="false"
              inputClass="teach-compensation-report-details-select"
              classes="mb-0"
            ></app-select>
          </div>
        </div>

        <div class="teach-compensation-report-details-toolbar-actions">
          <button
            type="button"
            class="btn teach-compensation-report-details-export-button"
            [disabled]="tableLoading() || datasource().total === 0"
            (click)="onOpenExportModal()"
          >
            Preview PDF
          </button>
        </div>
      </div>

      <div class="segmented-tabs segmented-tabs--sm teach-compensation-report-details-status-tabs" role="tablist" aria-label="สถานะคำขอสอนชดเชย">
        @for (tab of statusTabs; track tab.value) {
          <button
            type="button"
            class="segmented-tab teach-compensation-report-details-status-tab"
            role="tab"
            [attr.aria-selected]="activeTab() === tab.value"
            [class.active]="activeTab() === tab.value"
            (click)="onTabChange(tab.value)"
          >
            {{ tab.label }}
          </button>
        }
      </div>

      <ng-template #rowIndexTemplate let-rowIndex="rowIndex">
        {{ getDisplayRowIndex(rowIndex) }}
      </ng-template>

      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [mode]="tableColumnMode"
        [isLoading]="tableLoading()"
        [limit]="10"
        [showOrder]="false"
        [horizontalScrollByMinWidth]="true"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="teach compensation report detail pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>

  <div class="teach-compensation-report-details-bottom-actions">
    <button
      type="button"
      class="btn btn-light teach-compensation-report-details-back-button"
      (click)="onBack()"
    >
      กลับ
    </button>
  </div>
</div>

@if (isDetailModalOpen()) {
  <div
    class="teach-compensation-report-details-modal-overlay"
    role="presentation"
  >
    <div
      class="teach-compensation-report-details-modal-panel teach-compensation-report-details-detail-modal-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="teachCompensationReportDetailTitle"
    >
      @if (selectedRow(); as row) {
        <div class="teach-compensation-report-details-detail-header">
          <h5 id="teachCompensationReportDetailTitle">ข้อมูลคำขอสอนชดเชย</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="ปิด"
            (click)="onCloseModal()"
          ></button>
        </div>

        <div class="teach-compensation-report-details-detail-body">
          <section class="teach-compensation-report-details-detail-section">
            <h6>รายละเอียดผู้สอน</h6>
            <div class="teach-compensation-report-details-detail-grid">
              <p><strong>ชื่อ - นามสกุล :</strong> {{ getTeacherName(row) }}</p>
              <p><strong>สาขาวิชา :</strong> {{ getDepartmentName(row) }}</p>
            </div>
          </section>

          <section class="teach-compensation-report-details-detail-section">
            <h6>รายละเอียดการลา/หยุด</h6>
            <div class="teach-compensation-report-details-detail-grid">
              <p><strong>ประเภทการลา/หยุด :</strong> {{ row.raw.makeup_teaching_leave_type?.name ?? '-' }}</p>
              <p><strong>วันที่ลา :</strong> {{ formatDetailDate(row.raw.leave_date) }}</p>
              <p><strong>ช่วงเวลาการลา :</strong>
                @if (row.raw.makeup_teaching_leave_period; as leavePeriod) {
                  {{ leavePeriod.name ?? '-' }}
                  @if (leavePeriod.start_time && leavePeriod.end_time) {
                    ({{ formatDetailTimeRange(leavePeriod.start_time, leavePeriod.end_time) }})
                  }
                } @else {
                  -
                }
              </p>
            </div>
          </section>

          <section class="teach-compensation-report-details-detail-section">
            <h6>รายละเอียดรายวิชา</h6>
            <div class="teach-compensation-report-details-detail-grid">
              <p><strong>ชื่อรายวิชา :</strong> {{ getSelectedSubjectName(row) }}</p>
              <p><strong>รหัสวิชา :</strong> {{ getSelectedSubjectCode(row) }}</p>
              <p><strong>หลักสูตร :</strong> {{ getSelectedCurriculum(row) }}</p>
              <p><strong>ประเภทการสอน :</strong> {{ getSelectedStudyMode(row) }}</p>
              <p><strong>ค่าหน่วยกิต :</strong> {{ getSelectedCourseUnit(row) }}</p>
            </div>
          </section>

          <section class="teach-compensation-report-details-detail-section">
            <h6>รายละเอียดสอนชดเชย</h6>
            <div class="teach-compensation-report-details-detail-grid">
              <p><strong>วันที่ขอสอนชดเชย :</strong> {{ formatDetailDate(row.raw.makeup_teaching_date) }}</p>
              <p><strong>เวลาสอนชดเชย :</strong> {{ formatDetailTimeRange(row.raw.makeup_start_time?.label ?? row.raw.makeup_start_time?.time_value, row.raw.makeup_end_time?.label ?? row.raw.makeup_end_time?.time_value) }}</p>
              <p><strong>สถานะ :</strong> {{ row.statusLabel }}</p>
            </div>
          </section>
        </div>

      }
    </div>
  </div>
}

@if (isExportModalOpen()) {
  <div
    class="teach-compensation-report-details-modal-overlay"
    role="presentation"
  >
    <div
      class="teach-compensation-report-details-modal-panel teach-compensation-report-details-export-modal-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="teachCompensationReportExportTitle"
    >
      <div class="teach-compensation-report-details-detail-header">
        <h5 id="teachCompensationReportExportTitle">Export PDF รายงานคำขอสอนชดเชย</h5>
        <button
          type="button"
          class="btn-close"
          aria-label="ปิด"
          (click)="onCloseExportModal()"
        ></button>
      </div>

      <div class="teach-compensation-report-details-detail-body" [formGroup]="exportForm">
        <div class="teach-compensation-report-details-export-grid">
          <div class="teach-compensation-report-details-filter teach-compensation-report-details-export-filter-term">
            <app-select
              label="เทอมการศึกษา"
              formControlName="academicTerm"
              [options]="academicTermOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="teach-compensation-report-details-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="teach-compensation-report-details-filter teach-compensation-report-details-export-filter-year">
            <app-select
              label="ปีการศึกษา"
              formControlName="year"
              [options]="yearOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="teach-compensation-report-details-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="teach-compensation-report-details-filter teach-compensation-report-details-export-filter-month">
            <app-select
              label="เดือน (วันที่ลา/หยุด)"
              formControlName="month"
              [options]="exportMonthOptions"
              bindLabel="label"
              bindValue="value"
              [searchable]="false"
              [clearable]="false"
              inputClass="teach-compensation-report-details-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="teach-compensation-report-details-export-grid-actions">
            <button
              type="button"
              class="btn teach-compensation-report-details-export-button"
              [disabled]="pdfLoading() || exportDataLoading() || !exportHasData()"
              (click)="onDownloadExportPdf()"
            >
              Export PDF
            </button>
          </div>
        </div>

        @if (pdfLoading()) {
          <div class="teach-compensation-report-details-pdf-empty">
            กำลังโหลด PDF...
          </div>
        } @else if (pdfError()) {
          <div class="teach-compensation-report-details-pdf-empty">
            ไม่สามารถโหลด PDF ได้
          </div>
        } @else {
          @if (pdfPreviewUrl(); as previewUrl) {
            <iframe
              class="teach-compensation-report-details-pdf-preview"
              [src]="previewUrl"
              title="Preview PDF รายงานคำขอสอนชดเชย"
            ></iframe>
          } @else {
            <div class="teach-compensation-report-details-pdf-empty">
              ยังไม่มี PDF preview
            </div>
          }
        }
      </div>

      <div class="teach-compensation-report-details-detail-footer teach-compensation-report-details-export-footer">
        <button
          type="button"
          class="btn btn-light teach-compensation-report-details-export-cancel-button"
          (click)="onCloseExportModal()"
        >
          ยกเลิก
        </button>
      </div>
    </div>
  </div>
}
